module.exports = __webpack_public_path__ + "img/left1.25e38000.png";